import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PriceInputContainer = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 0.5rem;
  align-items: end;
`;

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label`
  font-size: 15px;
  font-weight: 700;
`;

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 40px;
  padding: 0 1rem;
  border-radius: 2rem;
  font-size: 15px;
`;

export const Select = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 40px;
  padding: 0 1rem;
  border-radius: 2rem;
  font-size: 15px;
  cursor: pointer;
  
  display: flex;
  align-items: center;
  
  color: transparent;
  text-align-last: center;
  
  option {
    color: #333;
    background-color: white;
    text-align: left;
  }
  
  &:not([value=""]) {
    color: #333;
    text-align-last: left;
  }
`;

export const PriceListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const PriceItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
`;

export const AddButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 0.5rem;
  
  &:hover {
    background-color: #c82333;
  }
`;
